import dayjs from "dayjs";
import { USER_DETAILS_KEY, USER_REDUCER_ACTIONS } from "../utils/constant";

const initialState = {
  user: {},
};

const appReducer = (state, action) => {
  switch (action.type) {
    case USER_REDUCER_ACTIONS.INTIALIZE_USER: {
      state = {
        user: action.payload.user,
      };
      localStorage.setItem(
        USER_DETAILS_KEY,
        JSON.stringify({
          user: action.payload?.user,
        })
      );
      return state;
    }
    case USER_REDUCER_ACTIONS.FETCH_USER: {
      // return user data
      return state;
    }
    case USER_REDUCER_ACTIONS.DELETE_USER: {
      // delete from localStorage
      localStorage.removeItem(USER_DETAILS_KEY);
      // delete user data from context
      return initialState;
    }
    case USER_REDUCER_ACTIONS.UPDATE_USER: {
      // update user data
      return state;
    }
    default:
      return state;
  }
};

export default appReducer;
